var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { InstantGameKeyHelper, LotteryKeyHelper } from "../services/modules/brand-client.service";
import { clientComponentModuleId } from "../styles/client/render-engine/render-engine.helper";
import { TokenClient } from "../services/authentication/token-client.service";
import { DialogClientService } from "../services/basics/dialog-client.service";
import { MobileHelper } from "./mobile-helper";
import { RouterConstants } from "../configuration/router.constants";
import { Router } from "aurelia-router";
import { autoinject } from "aurelia-framework";
var RoutingHelper = /** @class */ (function () {
    function RoutingHelper(tokenClient, dialogClient, router) {
        this.tokenClient = tokenClient;
        this.dialogClient = dialogClient;
        this.router = router;
    }
    RoutingHelper.prototype.getInstantGameKey = function (name) {
        var key = name ? InstantGameKeyHelper.getKey(name) : '';
        return key;
    };
    RoutingHelper.prototype.getLotteryKey = function (name) {
        var key = name ? LotteryKeyHelper.getKey(name) : '';
        return key;
    };
    RoutingHelper.prototype.showInstantGameDialog = function (instantGame) {
        var _this = this;
        if (this.tokenClient.isAuthenticated) {
            var key_1 = this.getInstantGameKey(instantGame.instantGameName);
            setTimeout(function () {
                _this.dialogClient.show(clientComponentModuleId("dialogs/instant-game-dialog"), {
                    instantGameId: instantGame.instantGameId,
                    key: key_1,
                    brandInstantGameId: instantGame.brandInstantGameId
                }, false, false, MobileHelper.isMobileDevice());
            }, 1000);
            window.dataLayer.push({
                "openedInstantGameId": instantGame.instantGameId,
                "openedInstantGameName": instantGame.instantGameName,
                "event": "navigate_instant_game"
            });
        }
        else {
            this.tokenClient.reloadUser();
        }
    };
    RoutingHelper.prototype.navigateToLottery = function (lottery) {
        var key = this.getLotteryKey(lottery.lotteryName);
        this.router.navigateToRoute(RouterConstants.RouteNames.Lottery, {
            lotteryId: lottery.lotteryId,
            key: key,
            brandLotteryId: lottery.brandLotteryId
        });
        window.dataLayer.push({
            "openedLotteryId": lottery.lotteryId,
            "openedLotteryName": lottery.lotteryName,
            "event": "navigate_lottery"
        });
    };
    RoutingHelper = __decorate([
        autoinject,
        __metadata("design:paramtypes", [TokenClient,
            DialogClientService,
            Router])
    ], RoutingHelper);
    return RoutingHelper;
}());
export { RoutingHelper };
